module.exports = __webpack_public_path__ + "assets/desktopSuccess-88f81c.svg";